module.exports = __webpack_public_path__ + "img/J11333.1f6bef84.png";